import securityApi from "src/features/security/api/clients/security-api";

export const generateSecurityMeilisearchKey = async (): Promise<string> => {
  const { data } = await securityApi.post<string>("/generate-search-key");

  return data;
};
